import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-light py-4 mt-5 border-top">
      <Container className="text-center">
        <p className="mb-1">© {new Date().getFullYear()} Restauracja Zadyma Niedzica.</p>
        {/* <p className="mb-0">
          <a href="/privacy-policy" className="text-muted text-decoration-none">Polityka prywatności</a> | 
          <a href="/terms" className="text-muted text-decoration-none ms-2">Regulamin</a>
        </p> */}
      </Container>
    </footer>
  );
};

export default Footer;
